import initQuotation from './loadListeners/quotation';
import initTracingRespondUser from './loadListeners/tracingRespondUser';
import scheduling from './loadListeners/scheduling';
import initTracingList from './loadListeners/tracingList';

const loadListeners = {
    '#quotation': initQuotation,
    '.section-tracing-respond-user': initTracingRespondUser,
    '.scheduling': scheduling,
    '#tracing-list': initTracingList,
};

export { loadListeners };
